import moment from 'moment';
import get from 'lodash/get';

import { PERIOD } from '../constants';

export const getVisibleDates = (config, period) => {
  const labels = get(config, 'data.labels', []);

  const [head, tail] = [labels[0], labels[labels.length - 1]];

  switch (period) {
    case PERIOD.DAY:
      return [moment(head).format('MMM D, YYYY')];
    case PERIOD.WEEK:
    case PERIOD.MONTH:
      return [
        moment(head).format('MMM D, YYYY'),
        moment(tail).format('MMM D, YYYY'),
      ];
    case PERIOD.QUARTER:
    case PERIOD.YEAR:
      return [
        moment(head).format('MMM, YYYY'),
        moment(tail).format('MMM, YYYY'),
      ];
    default:
      return [];
  }
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/getVisibleDates.js